import { useForm } from "react-hook-form";
import RadioGroup from "../../Components/CommonCommponents/RadioGroup";
import Input from "../../Components/CommonCommponents/Input";
import { useEffect } from "react";
import { Button } from "antd";
import Select from "../../Components/CommonCommponents/select/Select";
import AuthService from "../../Service.js/authService";
import { useState } from "react";
import DatePicker from "../../Components/CommonCommponents/DatePicker";
import CandodateService from "../../Service.js/CandidateService";
import toast from "react-hot-toast";
import { dateConverter } from "../../Components/Utilities/util";
import dayjs from "dayjs";
import TextArea from "../../Components/CommonCommponents/TextArea";
import TextEdit from "../../Components/CommonCommponents/TextEditor";

const AddProject = (props) => {
  console.log("props", props);
  const {
    register,
    control,
    setValue,
    setError,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm();

  const ANSWER_OPTIONS = [
    { label: "In progress", value: "false" },
    { label: "Finished", value: "true" },
  ];
  const [description, setDescrption] = useState();
  const selectedItem = watch("is_current_project");
  const onChange = (e) => {
    setDescrption(e);
  };
  const getExperieceinfo = async () => {
    await CandodateService.getProjectById(props.projectId)
      .then(
        (oResponse) => {
          console.log("oResponseccc", oResponse.data.data?.responsibilities);
          setDescrption(oResponse.data.data?.responsibilities);
          getData(oResponse.data.data);
        },
        (error) => {
          console.log("loginError", error);
        }
      )
      .catch((err) => {
        console.log(err);
      });
  };
  const projectInfo = async () => {
    await CandodateService.getProjectDetails()
      .then((response) => {
        console.log("response", response.data.data);
      })
      .catch((error) => {});
  };
  const getData = (data) => {
    console.log("testdata", data);
    setValue("is_current_project", data?.is_current_project.toString());
    setValue("project", data?.project);
    setValue("designation", data?.designation);
    setValue("worked_from", dayjs(data?.worked_from));
    setValue("worked_till", dayjs(data?.worked_till));
    setValue("company", data?.company);
    setValue("responsibilities", data?.responsibilities);
  };
  useEffect(() => {
    getExperieceinfo();
    getData();
  }, [props.details]);

  const sendData = async (data) => {
    console.log("tetslog", data);

    // const date = dateConverter(data.worked_from)
    // const worked_from = date.convertedValue
    // const date2 = dateConverter(data.till)
    // const worked_till = date2.convertedValue
    // data["worked_from"] = worked_from;
    // data["worked_till"] = worked_till;
    data["worked_from"] = dayjs(data.worked_from).format("YYYY-MM-DD");
    data["worked_till"] = dayjs(data.worked_till).format("YYYY-MM-DD");

    await CandodateService.addProject(data)
      .then(
        (oResponse) => {
          console.log("oResponse", oResponse);
          toast.success("Successfully Added!");
          props.close();
          projectInfo();
        },
        (error) => {
          console.log("loginError", error);
        }
      )
      .catch((err) => {
        console.log(err);
        toast.error("Failed To Add");
      });
  };
  const updateData = async (data) => {
    console.log("tetslog", data);

    // const date = dateConverter(data.worked_from)
    // const worked_from = date.convertedValue
    // const date2 = dateConverter(data.till)
    // const worked_till = date2.convertedValue
    // data["worked_from"] = worked_from;
    // data["worked_till"] = worked_till;
    data["worked_from"] = dayjs(data.worked_from).format("YYYY-MM-DD");
    data["worked_till"] = dayjs(data.worked_till).format("YYYY-MM-DD");

    await CandodateService.updateProjects(data, props.projectId)
      .then(
        (oResponse) => {
          console.log("oResponse", oResponse);
          toast.success("Successfully Added!");
          props.close();
          projectInfo();
        },
        (error) => {
          console.log("loginError", error);
        }
      )
      .catch((err) => {
        console.log(err);
        toast.error("Failed To Add");
      });
  };
  const onSubmit = async (data) => {
    data["responsibilities"] = description;
    if (props.projectId) {
      updateData(data);
    } else {
      sendData(data);
    }
  };
  return (
    <div className="w-full pb-6 p-4 flex">
      <form className=" w-full" onSubmit={handleSubmit(onSubmit)}>
        <div class="px-2">
          <div class="flex -mx-2 md:flex-row flex-col">
            <div class="w-full px-4">
              <Input
                name="project"
                label="Project Title"
                control={control}
                rules={{
                  required: "This field is required",
                }}
                className="h-12 "
              />
            </div>
          </div>
          <div class="flex -mx-2 md:flex-row flex-col">
            <div class="w-full px-4">
              <Input
                name="company"
                label="Company Name"
                control={control}
                rules={{
                  required: "This field is required",
                }}
                className="h-12 "
              />
            </div>
          </div>
          <div class="flex -mx-2 md:flex-row flex-col">
            <div class="w-full px-4">
              <RadioGroup
                name="is_current_project"
                label="Project Status"
                control={control}
                rules={{
                  required: "At least 1 option must be chosen.",
                  maxLength: 20,
                }}
                options={ANSWER_OPTIONS}
              />
            </div>
          </div>
          <div class="flex -mx-2 md:flex-row flex-col">
            <div class="w-full px-4">
              <DatePicker
                label="Worked From"
                name="worked_from"
                noTextInput
                showToday
                rules={{
                  required: "Please Choose a Date",
                }}
                control={control}
                placeholder="Select"
                // disablePreviousDays
                className="h-12"
                disableFutureDays={true}
                maxDate={dayjs().subtract(1, "day")} 
              />
            </div>
          </div>
          <div class="flex -mx-2 md:flex-row flex-col">
            <div class="w-full px-4">
              <DatePicker
                label="Worked Till"
                name="worked_till"
                disabled={selectedItem === "false"}
                noTextInput
                showToday
                rules={{
                  required: "Please Choose a Date",
                }}
                control={control}
                placeholder="Select"
                disableFutureDays={true}
                className="h-12"
              />
            </div>
          </div>
          <div class="flex -mx-2 md:flex-row flex-col">
            <div class="w-full px-4">
              <label className=" text-medium mb-2 text-start ">
                Details of Project
              </label>
              <div className="mt-4">
                <TextEdit
                  onChange={onChange}
                  id="description"
                  initialValue={description}
                />
              </div>
            </div>
          </div>
          {/* <div class="flex -mx-2 md:flex-row flex-col">
                        <div class="w-full px-4">
                            <TextArea
                                label="Details of Project"
                                name="responsibilities"
                                showArrow={true}
                                allowClear
                                rules={{
                                    required: "This field is required.",
                                }}
                                className="h-[28px]"
                                control={control}
                            />
                         
                        </div>
                    </div> */}
          <div class="flex -mx-2 md:flex-row flex-col">
            <div class="w-full px-4">
              <Input
                name="designation"
                label="Role"
                control={control}
                rules={{
                  required: "This field is required",
                }}
                className="h-12"
              />
            </div>
          </div>
        </div>
        <div className="flex flex-wrap justify-end mt-6 px-4">
          <Button
            htmlType="submit"
            type="submit"
            className="bg-[#000000] text-white text-base rounded-3xl"
          >
            Save
          </Button>
        </div>
      </form>
    </div>
    // <div>
    //      <RadioGroup
    //       name="is_correct_answer"
    //       label="Answer"
    //       control={control}
    //       rules={{
    //         required: 'At least 1 option must be chosen.', maxLength: 20
    //       }}
    //       options={ANSWER_OPTIONS}
    //     />
    // </div>
  );
};

export default AddProject;
